<header class="vl-content-header vl-content-header--large vl-content-header--show-mobile">
  <div class="vl-content-header__wrapper">
    <picture class="vl-content-header__bg">
      <img sizes="100vw" src="assets/images/Wiz-Banner-DoubleRes.png" alt="Content Header" />
    </picture>
    <div class="vl-layout">
      <div class="vl-content-header__content">
        <h2 class="vl-content-header__title">
          <span class="vl-content-header__title__content"> {{ 'HEADER.TITLE' | translate }} </span>
        </h2>
      </div>
    </div>
  </div>
</header>
